import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-046165ec")
const _hoisted_1 = { id: "game_activityWindows" }
const _hoisted_2 = {
  key: 0,
  class: "_header grid_top"
}
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = {
  key: 0,
  class: "_headerText"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "functions" }
const _hoisted_7 = { class: "blemishes" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "_loadPrompt"
}
const _hoisted_11 = {
  key: 2,
  class: "_main game"
}
const _hoisted_12 = {
  key: 0,
  class: "card"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "_giveMeSpace" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "You haven't gotten to this card yet."),
  /*#__PURE__*/_createElementVNode("p", null, "Click one you've unlocked below.")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "_backgroundNoClick"
}
const _hoisted_16 = {
  key: 10,
  class: "_backgroundBlur"
}
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = {
  key: 4,
  class: "list"
}
const _hoisted_20 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_21 = {
  key: 5,
  id: "game_lobby",
  class: "_nav"
}
const _hoisted_22 = { class: "_code" }
const _hoisted_23 = {
  key: 0,
  class: "pausedIndicator"
}
const _hoisted_24 = { class: "paused" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, "Game paused", -1)
const _hoisted_26 = {
  key: 0,
  class: "failIndicator stopped"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", null, "Oh no!", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "You were unable to escape! Why not try again?", -1)
const _hoisted_29 = { class: "_reviews" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "text" }, " How was your experience? ", -1)
const _hoisted_31 = { class: "emojis" }
const _hoisted_32 = {
  key: 1,
  class: "failIndicator stopped"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h1", null, "Well done! ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "You escaped! But the game's over...", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActivityWindow = _resolveComponent("ActivityWindow")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Countdown = _resolveComponent("Countdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_TutorialPopup = _resolveComponent("TutorialPopup")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CardDoor = _resolveComponent("CardDoor")!
  const _component_CardList = _resolveComponent("CardList")!
  const _component_LobbyWindow = _resolveComponent("LobbyWindow")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.GameView.lobby.players, (player) => {
        return (_openBlock(), _createBlock(_component_ActivityWindow, { player: player }, null, 8, ["player"]))
      }), 256))
    ]),
    (_ctx.$store.state.GameView.lobby && _ctx.$store.state.GameView.lobby.playthrough)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconButton, {
              icon: "back",
              white: true,
              onClick: _ctx.returnToLobby
            }, null, 8, ["onClick"])
          ]),
          (_ctx.$store.state.GameView.game)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Countdown, {
                  duration: _ctx.$store.state.GameView.game.minutes*60,
                  startTime: _ctx.$store.state.GameView.lobby.playthrough.started,
                  pausedAt: _ctx.$store.state.GameView.lobby.playthrough.paused,
                  delta: (_ctx.$store.state.GameView.lobby.playthrough.pauseSum - _ctx.$store.state.GameView.lobby.playthrough.skippedTime)/1000,
                  autoplay: true,
                  pausable: true,
                  forcePause: _ctx.$store.state.GameView.lobby.playthrough.paused,
                  stoppedAt: _ctx.$store.state.GameView.lobby.playthrough.finished || _ctx.$store.state.GameView.lobby.playthrough.stopped,
                  stopped: _ctx.$store.state.GameView.lobby.playthrough.stopped,
                  onPlay: _ctx.play,
                  onPause: _ctx.pause,
                  onStop: _ctx.stop
                }, null, 8, ["duration", "startTime", "pausedAt", "delta", "forcePause", "stoppedAt", "stopped", "onPlay", "onPause", "onStop"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Checkbox, {
              class: "hide",
              label: `Heads`,
              toggled: _ctx.$store.state.GameView.activityWindows,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('gameView_toggleActivityWindows')))
            }, null, 8, ["toggled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.$store.state.GameView.lobby.playthrough.hints)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Hints: " + _toDisplayString(_ctx.$store.state.GameView.lobby.playthrough.hints), 1))
              : _createCommentVNode("", true),
            (_ctx.$store.state.GameView.lobby.playthrough.skips)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Skips: " + _toDisplayString(_ctx.$store.state.GameView.lobby.playthrough.skips), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_LoadSpinner, { text: "Loading game" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.$store.state.GameView.lobby 
  && _ctx.$store.state.GameView?.lobby?.playthrough 
  && !_ctx.$store.state.GameView?.lobby?.playthrough?.paused
  && !_ctx.$store.state.GameView?.lobby?.playthrough?.stopped)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.$store.state.GameView.lobby.playthrough.currentCard < _ctx.$store.state.GameView.currentFocus.index || _ctx.$store.state.GameView.currentFocus == 'empty')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.isTutorial)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.tutorialPhase>0 && _ctx.tutorialPhase<2 && _ctx.tutorialPhase!=1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==0)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 1,
                      class: "fixed centre",
                      header: "Your first card",
                      body: "This page displays a card. Cards contain the information and questions you'll encounter during a game.",
                      stage: _ctx.tutorialPhase,
                      max: 4,
                      onForward: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==1)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 2,
                      class: "fixed bottom centre",
                      header: "What to do first",
                      body: "For each card, first read its text. Let's do this now.",
                      stage: _ctx.tutorialPhase,
                      max: 4,
                      nextText: "Done",
                      onForward: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==2)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 3,
                      class: "fixed bottom centre",
                      header: "A first step",
                      body: "This card also has an image, click it to have a better look.",
                      stage: _ctx.tutorialPhase,
                      max: 4,
                      onForward: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==3)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 4,
                      class: "fixed centre",
                      header: "We have what we need!",
                      body: "To recap: This card says to go to Aysgill Force, then to head north along a river until you reach a bridge. Once at the bridge, find a nearby Mill. You can use Google Maps to answer the question below.",
                      stage: _ctx.tutorialPhase,
                      max: 4,
                      nextText: "Okay",
                      tick: true,
                      onForward: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==4 && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus['nxwLRFDVbzx3FnI6Pi6E']?.complete)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 5,
                      class: "fixed centre",
                      header: "Well done!",
                      body: "Click the next button below the question to advance!",
                      stage: _ctx.tutorialPhase,
                      max: 4,
                      onForward: _cache[9] || (_cache[9] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : (_ctx.$store.state.GameView.currentFocus.index==1 && _ctx.tutorialPhase==4)
                    ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                        key: 6,
                        class: "fixed bright",
                        header: "Try and answer the question",
                        link: "https://www.google.com/maps/@54.2901322,-2.2103989,17z",
                        linkText: "Hint: Start here",
                        stage: _ctx.tutorialPhase,
                        max: 4,
                        onForward: _cache[11] || (_cache[11] = ($event: any) => (_ctx.tutorialPhase++)),
                        onBack: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tutorialPhase--))
                      }, null, 8, ["stage"]))
                    : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==2 && _ctx.tutorialPhase==4)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 7,
                      class: "fixed centre",
                      header: "Next card",
                      body: "During our games, you'll use all sorts of online resources. For this card, you'll be using Wikipedia!",
                      stage: _ctx.tutorialPhase,
                      max: 5,
                      onForward: _cache[13] || (_cache[13] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[14] || (_cache[14] = ($event: any) => {_ctx.tutorialPhase--; _ctx.tutorialCardBack(1); _ctx.tutorialPhase=4})
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==2 && _ctx.tutorialPhase==5 && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus['WYA8TSartOKPwFo6m9ot']?.complete)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 8,
                      class: "fixed centre",
                      header: "Great job!",
                      body: "You're getting the hang of things. Next card!",
                      stage: _ctx.tutorialPhase,
                      max: 5,
                      onForward: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[16] || (_cache[16] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : (_ctx.$store.state.GameView.currentFocus.index==2 && _ctx.tutorialPhase==5)
                    ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                        key: 9,
                        class: "fixed bright",
                        header: "See how you go",
                        link: "https://en.wikipedia.org/wiki/Gayle_Mill,_North_Yorkshire",
                        linkText: "Cheat: the answer is here",
                        stage: _ctx.tutorialPhase,
                        max: 5,
                        onForward: _cache[17] || (_cache[17] = ($event: any) => (_ctx.tutorialPhase++)),
                        onBack: _cache[18] || (_cache[18] = ($event: any) => (_ctx.tutorialPhase--))
                      }, null, 8, ["stage"]))
                    : _createCommentVNode("", true),
                ((_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==5))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==5)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 11,
                      class: "fixed centre",
                      header: "Another example",
                      body: "For this card, you'll have to do some work.",
                      stage: _ctx.tutorialPhase,
                      max: 8,
                      nextText: "Okay",
                      onForward: _cache[19] || (_cache[19] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[20] || (_cache[20] = ($event: any) => {_ctx.tutorialPhase--; _ctx.tutorialCardBack(2); _ctx.tutorialPhase=5})
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==6)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 12,
                      class: "fixed bottom",
                      header: "Files",
                      body: "Some cards have files to view or play. This one has an audio clip - click it to listen.",
                      stage: _ctx.tutorialPhase,
                      max: 8,
                      nextText: "Done",
                      onForward: _cache[21] || (_cache[21] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[22] || (_cache[22] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==7)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 13,
                      class: "fixed bottom",
                      header: "What now?",
                      body: "This card requires you to open a piano and play some notes. Find a virtual piano online, recreate the tune and mark down the four notes - it spells something.",
                      stage: _ctx.tutorialPhase,
                      max: 8,
                      nextText: "Done",
                      onForward: _cache[23] || (_cache[23] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[24] || (_cache[24] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==8)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 14,
                      class: "fixed bright",
                      header: "You should have 'CABA'",
                      body: "Fill in the gaps supplied in the card's text, go to Caba Argentina on Google Maps, and search for a large clock tower in the area. Its name is your answer.",
                      link: "https://www.google.com/maps/place/Torre+Monumental/@-34.5921854,-58.3749436,17z/data=!4m9!1m2!2m1!1sclock+tower+CABA,+Buenos+Aires,+Argentina!3m5!1s0x95bccab50733c631:0x35a9423c5e0f240e!8m2!3d-34.5922346!4d-58.3737878!15sCiljbG9jayB0b3dlciBDQUJBLCBCdWVub3MgQWlyZXMsIEFyZ2VudGluYVopIidjbG9jayB0b3dlciBjYWJhIGJ1ZW5vcyBhaXJlcyBhcmdlbnRpbmGSAQhtb251bWVudJoBJENoZERTVWhOTUc5blMwVkpRMEZuU1VSdGVUWXRhV3BSUlJBQg",
                      linkText: "Cheat: This is the answer",
                      stage: _ctx.tutorialPhase,
                      max: 9,
                      nextText: "I'll try",
                      onForward: _cache[25] || (_cache[25] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[26] || (_cache[26] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==9 && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus['ubICPixbKZFns1fmm23P']?.complete)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 15,
                      class: "fixed centre",
                      header: "Well done!",
                      body: "The final step remains.",
                      stage: _ctx.tutorialPhase,
                      max: 8,
                      onForward: _cache[27] || (_cache[27] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[28] || (_cache[28] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : (_ctx.$store.state.GameView.currentFocus.index==3 && _ctx.tutorialPhase==9)
                    ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                        key: 16,
                        class: "fixed bright",
                        header: "Try and solve the card",
                        stage: _ctx.tutorialPhase,
                        max: 9,
                        onForward: _cache[29] || (_cache[29] = ($event: any) => (_ctx.tutorialPhase++)),
                        onBack: _cache[30] || (_cache[30] = ($event: any) => (_ctx.tutorialPhase--))
                      }, null, 8, ["stage"]))
                    : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==9)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 17,
                      class: "fixed centre",
                      header: "You're at the door",
                      body: "This is the final step in the game - one final question without hints.",
                      stage: _ctx.tutorialPhase,
                      max: 11,
                      onForward: _cache[31] || (_cache[31] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[32] || (_cache[32] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==10)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 18,
                      class: "fixed centre",
                      header: "So what's the answer?",
                      body: "When at the door, you may have to consider all the information provided during the game.",
                      stage: _ctx.tutorialPhase,
                      max: 11,
                      onForward: _cache[33] || (_cache[33] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[34] || (_cache[34] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==11)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 19,
                      class: "fixed centre",
                      header: "What does this mean?",
                      body: "In this instance, refer to the titles of each card you've played. A list of unlocked cards is provided at the bottom of the page.",
                      stage: _ctx.tutorialPhase,
                      max: 12,
                      nextText: "Okay",
                      onForward: _cache[35] || (_cache[35] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[36] || (_cache[36] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==12)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 20,
                      class: "fixed centre",
                      header: "But what's the answer?",
                      body: "The titles read: 'The Sender, they were with you, when you were born'. Make some guesses to find the answer.",
                      stage: _ctx.tutorialPhase,
                      max: 13,
                      nextText: "I'll try",
                      onForward: _cache[37] || (_cache[37] = ($event: any) => (_ctx.tutorialPhase++)),
                      onBack: _cache[38] || (_cache[38] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==13 && _ctx.$store.state.GameView.lobby.playthrough.finished)
                  ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                      key: 21,
                      class: "fixed bright",
                      header: "Well done, you won!",
                      body: "This concludes the tutorial. Please leave a rating and close this game.",
                      stage: _ctx.tutorialPhase,
                      max: 14,
                      nextText: "Exit",
                      onForward: _cache[39] || (_cache[39] = ($event: any) => (_ctx.$router.push({path:'/app/'}))),
                      onBack: _cache[40] || (_cache[40] = ($event: any) => (_ctx.tutorialPhase--))
                    }, null, 8, ["stage"]))
                  : (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==13 && _ctx.$store.state.GameView.lobby.playthrough.cardStatus['door']?.correct)
                    ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                        key: 22,
                        class: "fixed bottom centre",
                        header: "Great job!",
                        body: "Now all that is left is to click the door to escape!",
                        stage: _ctx.tutorialPhase,
                        max: 13,
                        nextText: "Okay",
                        onForward: _cache[41] || (_cache[41] = ($event: any) => (_ctx.tutorialPhase++)),
                        onBack: _cache[42] || (_cache[42] = ($event: any) => (_ctx.tutorialPhase--))
                      }, null, 8, ["stage"]))
                    : (_ctx.$store.state.GameView.currentFocus=='door' && _ctx.tutorialPhase==13)
                      ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                          key: 23,
                          class: "fixed bright",
                          header: "Try and solve the card",
                          stage: _ctx.tutorialPhase,
                          max: 13,
                          nextText: "Okay",
                          onForward: _cache[43] || (_cache[43] = ($event: any) => (_ctx.tutorialPhase++)),
                          onBack: _cache[44] || (_cache[44] = ($event: any) => (_ctx.tutorialPhase--))
                        }, null, 8, ["stage"]))
                      : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.$store.state.GameView.cards && _ctx.$store.state.GameView.cards.data)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.$store.state.GameView.cards.data, (card) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_Card, {
                    card: card,
                    highlightText: _ctx.tutorialPhase==1 || _ctx.tutorialPhase==2,
                    hideAllButFiles: _ctx.tutorialPhase==6,
                    unhideImage: _ctx.tutorialPhase==2
                  }, null, 8, ["card", "highlightText", "hideAllButFiles", "unhideImage"])
                ]))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.$store.state.GameView.currentFocus == 'door')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_CardDoor)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$store.state.GameView.cards && _ctx.$store.state.GameView.cards.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.tutorialPhase==1 || _ctx.tutorialPhase==6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                  : _createCommentVNode("", true),
                _createVNode(_component_CardList, {
                  cards: _ctx.$store.state.GameView.cards.data,
                  cardStatus: _ctx.$store.state.GameView.lobby.playthrough.cardStatus
                }, null, 8, ["cards", "cardStatus"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$store.state.GameView.lobby 
    && _ctx.$store.state.GameView.lobby.playthrough 
    && !_ctx.$store.state.GameView.lobby?.playthrough?.paused
    && !_ctx.$store.state.GameView.lobby?.playthrough?.stopped)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$store.state.GameView.lobby.meta.code), 1),
                (_ctx.$store.state.GameView.lobby)
                  ? (_openBlock(), _createBlock(_component_LobbyWindow, {
                      key: 0,
                      small: true
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.$store.state.GameView.lobby.playthrough)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_ctx.$store.state.GameView.lobby.playthrough.paused)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_MovingIcon, {
                      name: "pause",
                      type: "svg"
                    }),
                    _hoisted_25
                  ]),
                  _createVNode(_component_IconButton, {
                    icon: "start",
                    type: "svg",
                    text: "Resume",
                    onClick: _ctx.play
                  }, null, 8, ["onClick"])
                ]))
              : (_ctx.$store.state.GameView.lobby?.playthrough?.stopped)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!_ctx.$store.state.GameView.lobby.playthrough.finished)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_IconButton, {
                              icon: "back",
                              type: "svg",
                              text: "Back to lobby",
                              onClick: _ctx.returnToLobby
                            }, null, 8, ["onClick"]),
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", {
                                class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===1}),
                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.rate(1)))
                              }, "😒", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===3}),
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.rate(3)))
                              }, "😐", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass({_img:true, _emoji:true, _selected:_ctx.$store.state.GameView.rating===5}),
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.rate(5)))
                              }, "😄", 2)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _hoisted_33,
                          _hoisted_34,
                          _createVNode(_component_IconButton, {
                            icon: "back",
                            type: "svg",
                            text: "Exit",
                            colored: true,
                            hex: "#fff",
                            onClick: _ctx.returnToLobby
                          }, null, 8, ["onClick"])
                        ]))
                  ], 64))
                : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ], 64))
}